import { render, staticRenderFns } from "./AddressVerifyModal.vue?vue&type=template&id=3deb7877&scoped=true&lang=pug&"
import script from "./AddressVerifyModal.vue?vue&type=script&lang=js&"
export * from "./AddressVerifyModal.vue?vue&type=script&lang=js&"
import style0 from "./AddressVerifyModal.vue?vue&type=style&index=0&id=3deb7877&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3deb7877",
  null
  
)

export default component.exports